import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=2d50a3aa&scoped=true"
import script from "./aside.vue?vue&type=script&lang=ts"
export * from "./aside.vue?vue&type=script&lang=ts"
import style0 from "./aside.vue?vue&type=style&index=0&id=2d50a3aa&prod&lang=less"
import style1 from "./aside.vue?vue&type=style&index=1&id=2d50a3aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50a3aa",
  null
  
)

export default component.exports